import { fridaAuthConfig } from './msal-config';

const normalizedApiBaseUrl = fridaAuthConfig.apiBaseUrl.replace(/\/+$/, '');

/** Builds an absolute API URL, e.g. `apiUrl('Country')` -> `${apiBaseUrl}/Country`. */
export function apiUrl(path: string): string {
  return `${normalizedApiBaseUrl}/${path.replace(/^\/+/, '')}`;
}
